export const SERVICE_ID = '19b10000-e8f2-537e-4f6c-d104768a1214'
export const CHARACTERISTIC_ID = '19b10001-e8f2-537e-4f6c-d104768a1214'
